import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { SchedulerEvent } from '@progress/kendo-angular-scheduler';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { CommonConstants } from 'src/app-core/constants/common-constants';
import { CommonService } from 'src/app-core/services/common.service';
import { AppointmentsService } from 'src/app/appointments/appointments.service';
import { AppointmentDetailsPopupComponent } from '../appointment-details-popup/appointment-details-popup.component';

@Component({
    selector: 'app-appointments-tasks-calendar',
    templateUrl: './appointments-tasks-calendar.component.html',
    styleUrls: ['./appointments-tasks-calendar.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AppointmentsTasksCalendarComponent implements OnInit {

    @Output() emitLoadTimeSlot: EventEmitter<any> = new EventEmitter<any>();
    @Output() emitEditAppointment: EventEmitter<any> = new EventEmitter<any>();
    @Input() set appointmentFilterParams(data: any) {
        this.appointmentFilter = data;
        this.getAppointments();
    }
    isAppointmentsLoading = false;
    dailref: any;

    resources: any = [
        {
            data: [
                { text: '', value: 'pickup', color: '#0d4e8f' },
                { text: '', value: 'delivery', color: '#0e7eef' },
                { text: '', value: 'onsite_survey', color: '#6d94bb' },
                { text: '', value: 'sales', color: '#69a876' },
                { text: '', value: 'onsite_build', color: '#874fba' },
                { text: '', value: 'onsite_survey', color: '#6d94bb' },
                { text: '', value: 'other', color: '#874fba' }
            ],
            field: 'eventType',
            valueField: 'value',
            textField: 'text',
            colorField: 'color'
        }
    ];

    currentDateObject = new Date();
    currentDate = {
        year: this.currentDateObject.getFullYear(),
        month: this.currentDateObject.getMonth(),
        date: this.currentDateObject.getDate()
    };
    timeSlotFromCalendar: any;
    appointmentFilter: any;
    currentView = CommonConstants.appointmentFormConstant.month;
    dateFormat = CommonConstants.appComponent.dateFormat;
    selectedViewIndex = 2;
    orderId: any;
    isJobsAppointments = false;

    selectedDate: any = new Date(this.currentDate.year, this.currentDate.month, this.currentDate.date);
    setDate: any = moment().format(this.dateFormat);
    appointmentsList: SchedulerEvent[] = null;

    constructor(
        private commonService: CommonService,
        private activatedRoute: ActivatedRoute,
        private toastr: ToastrService,
        private dialog: MatDialog,
        private appointmentsService: AppointmentsService) {
        if (this.activatedRoute.snapshot.queryParams.quoteId) {
            this.orderId = this.activatedRoute.snapshot.queryParams.quoteId;
            this.isJobsAppointments = false;
        } else {
            this.orderId = this.activatedRoute.snapshot.queryParams.jobId;
            this.isJobsAppointments = true;
        }
    }

    ngOnInit() {
    }

    getDateObject = (appointmentDate: string, timeSpan: string) => {
        const eventDate = new Date(appointmentDate);
        const time = timeSpan.split(':');
        eventDate.setHours((+time[0]));
        eventDate.setMinutes((+time[1]));
        eventDate.setSeconds((+time[2]));
        return new Date(eventDate);
    }

    getAppointments() {
        this.onMonthViewStyleClass();
        this.isAppointmentsLoading = true;
        this.commonService.getAppointmentsForCalView(this.getFilter())
            .pipe(finalize(() => (this.isAppointmentsLoading = false)))
            .subscribe(response => {
                this.isAppointmentsLoading = false;
                if (response.isSuccess) {
                    this.appointmentsList = response.data.items.map(dataItem => (
                        {
                            eventId: dataItem.eventId,
                            start: this.getDateObject(dataItem.appointmentDate, dataItem.startTime),
                            end: this.getDateObject(dataItem.appointmentDate, dataItem.endTime),
                            description: dataItem.description,
                            jobId: dataItem.displayId,
                            itemCount: dataItem.itemsCount,
                            title: dataItem.displayId,
                            orderId: dataItem.orderId,
                            orderLongId: dataItem.orderlongId,
                            appointmentTypeId: dataItem.appointmentTypeId,
                            employeeName: dataItem.employeeName,
                            employeeId: dataItem.employeeId,
                            appointmentDate: dataItem.appointmentDate,
                            contactName: dataItem.contactName,
                            contactId: dataItem.contactId,
                            vehicleId: dataItem.vehicleId,
                            vehicleName: dataItem.vehicleName,
                            driverId: dataItem.driverId,
                            driverName: dataItem.driverName,
                            note: dataItem.note,
                            isNotifyEmployee: dataItem.isNotifyEmployee,
                            appointmentId: dataItem.appointmentId,
                            eventType: this.appointmentsService.getEventType(dataItem.appointmentType)
                        } as SchedulerEvent
                    ));
                }
            });
    }

    getTimeSlot(timeSlot: any) {
        this.timeSlotFromCalendar = timeSlot;
        if (this.currentView === CommonConstants.appointmentFormConstant.month) {
            this.timeSlotFromCalendar.end = moment(timeSlot.start).add(30, 'minutes').format();
        }
        this.emitLoadTimeSlot.emit(this.timeSlotFromCalendar);
    }

    onNavigate(data: any) {

        switch (data.action.type) {
            case CommonConstants.appointmentFormConstant.viewChange:
                if (data.action.view.name === CommonConstants.appointmentFormConstant.day) {
                    this.currentView = CommonConstants.appointmentFormConstant.day;
                } else if (data.action.view.name === CommonConstants.appointmentFormConstant.week) {
                    this.currentView = CommonConstants.appointmentFormConstant.week;
                } else if (data.action.view.name === CommonConstants.appointmentFormConstant.month) {
                    this.currentView = CommonConstants.appointmentFormConstant.month;
                }
                this.setDate = moment(data.sender._selectedDate.getFullYear() + '-'
                    + (data.sender._selectedDate.getMonth() + 1) + '-' + data.sender._selectedDate.getDate()).format(this.dateFormat);
                this.getAppointments();
                break;
            case CommonConstants.appointmentFormConstant.today:
                this.setCurrentViewAndDate(this.currentView, CommonConstants.appointmentFormConstant.today);
                this.getAppointments();
                break;
            case CommonConstants.appointmentFormConstant.next:
                this.setDate = moment(data.sender._selectedDate.getFullYear() + '-'
                    + (data.sender._selectedDate.getMonth() + 1) + '-' + data.sender._selectedDate.getDate());
                this.setCurrentViewAndDate(this.currentView, CommonConstants.appointmentFormConstant.next);
                this.getAppointments();
                break;
            case CommonConstants.appointmentFormConstant.prev:
                this.setDate = moment(data.sender._selectedDate.getFullYear() + '-'
                    + (data.sender._selectedDate.getMonth() + 1) + '-' + data.sender._selectedDate.getDate());
                this.setCurrentViewAndDate(this.currentView, CommonConstants.appointmentFormConstant.prev);
                this.getAppointments();
                break;
            case CommonConstants.appointmentFormConstant.showDate:
                if (data.action && data.action.date) {
                    this.setDate = moment(data.action.date).format('YYYY-MM-DD');
                } else {
                    this.setDate = moment(data.sender._selectedDate.getFullYear() + '-' + (data.sender._selectedDate.getMonth() + 1) + '-' + data.sender._selectedDate.getDate());
                }
                this.currentView = CommonConstants.appointmentFormConstant.day;
                break;
            case CommonConstants.appointmentFormConstant.selectDate:
                this.setDate = moment(data.action.date).format(CommonConstants.appComponent.dateFormat);
                this.getAppointments();
                break;
        }
    }

    setCurrentViewAndDate(name: string, type: string) {
        const date = new Date();
        switch (name) {
            case CommonConstants.appointmentFormConstant.day:
                if (type === CommonConstants.appointmentFormConstant.today) {
                    this.setDate = moment().format(this.dateFormat);
                }
                if (type === CommonConstants.appointmentFormConstant.next) {
                    this.setDate = this.getSetDate(1, 'days');
                }
                if (type === CommonConstants.appointmentFormConstant.prev) {
                    this.setDate = this.getSetDate(-1, 'days');
                }
                this.currentView = CommonConstants.appointmentFormConstant.day;
                break;
            case CommonConstants.appointmentFormConstant.week:
                this.currentView = CommonConstants.appointmentFormConstant.week;
                if (type === CommonConstants.appointmentFormConstant.today) {
                    this.setDate = moment().format(this.dateFormat);
                }
                if (type === CommonConstants.appointmentFormConstant.next) {
                    this.setDate = this.getSetDate(1, 'weeks');
                }
                if (type === CommonConstants.appointmentFormConstant.prev) {
                    this.setDate = this.getSetDate(-1, 'weeks');
                }
                break;
            case CommonConstants.appointmentFormConstant.month:
                this.currentView = CommonConstants.appointmentFormConstant.month;
                if (type === CommonConstants.appointmentFormConstant.today) {
                    this.setDate = moment().format(this.dateFormat);
                }
                if (type === CommonConstants.appointmentFormConstant.next) {
                    this.setDate = this.getSetDate(1, 'months');
                }
                if (type === CommonConstants.appointmentFormConstant.prev) {
                    this.setDate = this.getSetDate(-1, 'months');
                }
                break;
        }
    }


    getSetDate(addNumber: number, type: any): any {
        return moment(this.setDate.format(this.dateFormat)).add(addNumber, type).format(this.dateFormat);
    }

    getFilter(): any {
        let filterQuery = `&isActive=true&IsListView=false&CalenderDate=${this.setDate}`;
        filterQuery += `&CalenderViewTypeId=${this.currentView === CommonConstants.appointmentFormConstant.day
            ? 1 : this.currentView === CommonConstants.appointmentFormConstant.week ? 2 : 3}`;
        if (this.appointmentFilter.orderId) {
            filterQuery += `&IsJob=${this.isJobsAppointments}`;
        }
        if (this.appointmentFilter) {
            if (!this.appointmentFilter.isAllJOb) {
                filterQuery += `&OrderId=${this.appointmentFilter.orderId}`;
            }
            if (this.appointmentFilter.employeeId) {
                filterQuery += `&EmployeeId=${this.appointmentFilter.employeeId}`;
            } else {
                filterQuery += `&EmployeeId=0`;
            }
            if (this.appointmentFilter.driverId) {
                filterQuery += `&DriverId=${this.appointmentFilter.driverId}`;
            } else {
                filterQuery += `&DriverId=0`;
            }
            if (this.appointmentFilter.appointmentType && this.appointmentFilter.appointmentType.length > 0) {
                let appointmentQuery = '';
                this.appointmentFilter.appointmentType.map(item => appointmentQuery += '&AppointmentTypeIds=' + item).toString();
                filterQuery += appointmentQuery;
            }
        }
        return filterQuery;
    }

    onEditAppointment(event: any, isClickedIcon: boolean) {
        const dataItem = isClickedIcon ? event.dataItem : event.event.dataItem;
        this.emitEditAppointment.emit(dataItem);
    }

    onMonthViewStyleClass() {
        const currentDate = moment(this.setDate).format('MMMM');
        if (this.currentView === CommonConstants.appointmentFormConstant.day
            || this.currentView === CommonConstants.appointmentFormConstant.week) {
            return '';
        } else {
            return `kendo_schedular_month_view ${currentDate}`;
        }
    }

    onRemove(dataItem: any) {
        this.commonService.getConfirmationPopup
            (CommonConstants.appointmentFormConstant.removeAppointmentConfirmation,
                CommonConstants.appComponent.cancel, CommonConstants.appComponent.confirm).then(result => {
                    if (result) {
                        const requestBody = {
                            appointmentId: dataItem.appointmentId,
                            isActive: false
                        };
                        this.isAppointmentsLoading = true;
                        this.commonService.deleteAppointment(requestBody)
                            .pipe(finalize(() => (this.isAppointmentsLoading = false)))
                            .subscribe((response: any) => {
                                if (response.isSuccess) {
                                    this.toastr.success(response.errors
                                        || CommonConstants.appointmentFormConstant.appointmentRemovedSuccessfully);
                                    this.getAppointments();
                                } else {
                                    this.toastr.error(response.errors
                                        || CommonConstants.appComponent.somethingWenWrongPleaseReTry, CommonConstants.appComponent.error);
                                }
                                this.isAppointmentsLoading = false;
                            });
                    }
                });
    }

    onMouseEnter(event: any, cursorLocation: any) {
        const cursorXPosition = (window.innerWidth - (cursorLocation.clientX + 600)) > 0
            ? cursorLocation.clientX : (cursorLocation.clientX - 500);
        const cursorYPosition = (window.innerHeight - (cursorLocation.clientY + 400)) > 0
            ? cursorLocation.clientY : (cursorLocation.clientY - 200);
        this.dailref = this.dialog
            .open(AppointmentDetailsPopupComponent, {
                panelClass: 'small_center_layout',
                hasBackdrop: false,
                data: event.dataItem,
                autoFocus: false,
                width: '30vw',
                position: {
                    left: cursorXPosition + 'px',
                    top: cursorYPosition + 'px'
                }
            }).afterClosed()
            .subscribe();
    }
}
